const deleteModelUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteModelUseCase;